import { Dayjs } from 'dayjs';
import { Schicht } from './Schicht';

export class Zeitstempel {
  constructor({
    abweichung,
    zeitpunkt,
    schicht,
  }: {
    abweichung: number;
    zeitpunkt: Dayjs;
    schicht?: Schicht;
  }) {
    this.abweichung = abweichung;
    this.zeitpunkt = zeitpunkt;
    this.schicht = schicht;
  }
  readonly abweichung: number;
  readonly zeitpunkt: Dayjs;
  readonly schicht?: Schicht;
}
